export interface Bq4SafetyManagementM {
  docValid: string;
  docValidComments: string;
  docCertificateNumber: string;
  docIssuingAuthority: string;
  smcCertificateNumber: string;
  smcCertifyingAuthority: string;
  vesselSubjectClass: string;
  operatedUnderQMS: string;
  qmsType: string;
  icsGuideComply: string;
  winchOrLandingArea: string;
  circleDiameter: string;
}

export const initialBq4SafetyManagement: Bq4SafetyManagementM = {
  docValid: "",
  docValidComments: "",
  docCertificateNumber: "",
  docIssuingAuthority: "",
  smcCertificateNumber: "",
  smcCertifyingAuthority: "",
  vesselSubjectClass: "",
  operatedUnderQMS: "",
  qmsType: "",
  icsGuideComply: "",
  winchOrLandingArea: "",
  circleDiameter: "",
};

export function mapSqlToBq4SafetyManagementForm(genInfo: any): Bq4SafetyManagementM {
  return {
    docValid: genInfo?.DOC_VALID || "",
    docValidComments: genInfo?.DOC_VALID_COMMENTS || "",
    docCertificateNumber: genInfo?.DOC_CERTIFICATE_NUMBER || "",
    docIssuingAuthority: genInfo?.DOC_ISSUING_AUTHORITY || "",
    smcCertificateNumber: genInfo?.SMC_CERTIFICATE_NUMBER || "",
    smcCertifyingAuthority: genInfo?.SMC_CERTIFYING_AUTHORITY || "",
    vesselSubjectClass: genInfo?.VESSEL_SUBJECT_CLASS || "",
    operatedUnderQMS: genInfo?.OPERATED_UNDER_QMS || "",
    qmsType: genInfo?.QMS_TYPE || "",
    icsGuideComply: genInfo?.ICS_GUIDE_COMPLY || "",
    winchOrLandingArea: genInfo?.WINCH_OR_LANDING_AREA || "",
    circleDiameter: genInfo?.CIRCLE_DIAMETER || "",
  };
}
